import Cookies from 'js-cookie'

export default {
  namespaced: true,
  state: {
    device: null
  },
  mutations: {
    setDevice (state, device) {
      state.device = device
      let domain = `.${process.env.VUE_APP_BASE_DOMAIN}`
      if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        domain = window.location.hostname
      }
      if (device) {
        Cookies.set('yz_device', device, { domain })
      } else {
        Cookies.remove('yz_device')
      }
    },
    setCompanySlug (state, companySlug) {
      let domain = `.${process.env.VUE_APP_BASE_DOMAIN}`
      if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        domain = window.location.hostname
      }
      if (companySlug) {
        Cookies.set('yz_last_company_slug', companySlug, { domain, expires: 30 })
      } else {
        Cookies.remove('yz_last_company_slug')
      }
    }
  }
}